<template>

  <div class="q-pa-sm">


    <!--    <q-item style="font-size: 20px">-->
    <!--      <q-item-section avatar>-->
    <!--        <q-icon name="offline_bolt" class="text-bold"></q-icon>-->
    <!--      </q-item-section>-->
    <!--      <q-item-section>-->
    <!--        <q-item-label class="text-bold">-->
    <!--          {{ zip_code }} ({{ selected_tdsp?.short_name }})-->
    <!--        </q-item-label>-->
    <!--      </q-item-section>-->
    <!--    </q-item>-->

    <!--    <q-btn class="text-bold q-mb-sm" no-caps flat color="light-blue-5" label="Change Zip Code"-->
    <!--           @click="clear_zip_code"></q-btn>-->


    <div class="q-my-md text-bold">
      <div>Showing {{ filtered_plans.length }} of {{ total_plans }} plans</div>
    </div>

    <div class="q-mb-md">
      <div class="text-bold">Filters currently applied</div>
      <selected-filters/>
    </div>


    <div class="text-bold">Filter your must haves:</div>
    <div class="text-bold">(select all that apply)</div>

    <q-list class="text-blue-grey-5" dense>

      <!--      <q-item clickable :active="has_no_filters"-->
      <!--              @click="clear_all_filters" active-class="primary">-->
      <!--        &lt;!&ndash;        <q-item-section avatar class="gt-xs">&ndash;&gt;-->
      <!--        &lt;!&ndash;          <q-icon name="visibility"></q-icon>&ndash;&gt;-->
      <!--        &lt;!&ndash;        </q-item-section>&ndash;&gt;-->
      <!--        <q-item-section>-->
      <!--          <q-item-label>-->
      <!--            Show all-->
      <!--          </q-item-label>-->
      <!--        </q-item-section>-->
      <!--        <q-item-section avatar>-->
      <!--          <q-toggle class="text-blue-grey-8" color="primary" v-model="has_no_filters"></q-toggle>-->
      <!--        </q-item-section>-->
      <!--      </q-item>-->

      <!--      <q-item clickable :active="include_auto_pay.selected"-->
      <!--              @click="include_auto_pay.selected = !include_auto_pay.selected">-->
      <!--        &lt;!&ndash;        <q-item-section avatar class="gt-xs">&ndash;&gt;-->
      <!--        &lt;!&ndash;          <q-icon name="credit_score"></q-icon>&ndash;&gt;-->
      <!--        &lt;!&ndash;        </q-item-section>&ndash;&gt;-->
      <!--        <q-item-section>-->
      <!--          <q-item-label>-->
      <!--            Autopay-->
      <!--          </q-item-label>-->
      <!--        </q-item-section>-->
      <!--        <q-item-section avatar>-->
      <!--          <q-toggle class="text-blue-grey-8" color="primary" v-model="include_auto_pay.selected"></q-toggle>-->
      <!--        </q-item-section>-->
      <!--      </q-item>-->

      <!--      <q-item clickable :active="has_long_term_filter" @click="toggle_long_term">-->
      <!--        <q-item-section avatar>-->
      <!--          <q-icon name="hourglass_full"></q-icon>-->
      <!--        </q-item-section>-->
      <!--        <q-item-section>-->
      <!--          <q-item-label>-->
      <!--            Long term-->
      <!--          </q-item-label>-->
      <!--        </q-item-section>-->
      <!--        <q-item-section avatar>-->
      <!--          <q-toggle class="text-blue-grey-8" color="primary" v-model="has_long_term_filter"></q-toggle>-->
      <!--        </q-item-section>-->
      <!--      </q-item>-->
      <q-item clickable :active="only_100_percent_green.selected"
              @click="only_100_percent_green.selected = !only_100_percent_green.selected">
        <q-item-section avatar>
          <q-toggle class="text-blue-grey-8" color="primary" v-model="only_100_percent_green.selected"
                    :class="only_100_percent_green.disabled ? 'text-blue-grey-4' : 'text-blue-grey-8'"
          ></q-toggle>
        </q-item-section>
        <q-item-section>
          <q-item-label>
            Show 100% Green only
          </q-item-label>
        </q-item-section>
        <!--        <q-item-section avatar class="gt-xs">-->
        <!--          <q-icon name="energy_savings_leaf"></q-icon>-->
        <!--        </q-item-section>-->
      </q-item>


      <!--      <q-item clickable :active="has_no_contract_filter" @click="toggle_no_contract">-->
      <!--        <q-item-section avatar>-->
      <!--          <q-icon name="folder_off"></q-icon>-->
      <!--        </q-item-section>-->
      <!--        <q-item-section>-->
      <!--          <q-item-label>-->
      <!--            Show only no contract plans-->
      <!--          </q-item-label>-->
      <!--        </q-item-section>-->
      <!--        <q-item-section avatar>-->
      <!--          <q-toggle class="text-blue-grey-8" color="primary" v-model="has_no_contract_filter"></q-toggle>-->
      <!--        </q-item-section>-->
      <!--      </q-item>-->


      <q-item clickable :active="only_no_deposit.selected"
              @click="only_no_deposit.selected = !only_no_deposit.selected">
        <!--        <q-item-section avatar class="gt-xs">-->
        <!--          <q-icon name="credit_card_off"></q-icon>-->
        <!--        </q-item-section>-->

        <q-item-section avatar>
          <q-toggle color="primary" v-model="only_no_deposit.selected"
                    :class="only_no_deposit.disabled ? 'text-blue-grey-4' : 'text-blue-grey-8'"
          ></q-toggle>
        </q-item-section>
        <q-item-section>
          <q-item-label>
            Show no deposit only
          </q-item-label>
        </q-item-section>
      </q-item>

      <q-item clickable :active="only_time_of_use.selected"
              @click="only_time_of_use.selected = !only_time_of_use.selected">
        <!--        <q-item-section avatar class="gt-xs">-->
        <!--          <q-icon name="lightbulb"></q-icon>-->
        <!--        </q-item-section>-->
        <q-item-section avatar>
          <q-toggle color="primary" v-model="only_time_of_use.selected"
                    :class="only_time_of_use.disabled ? 'text-blue-grey-4' : 'text-blue-grey-8'"
          ></q-toggle>
        </q-item-section>
        <q-item-section>
          <q-item-label>
            Show free nights / weekends only
          </q-item-label>
        </q-item-section>
      </q-item>

    </q-list>

    <!--    <q-card-section class="q-mt-lg">-->
    <!--      <div class="text-125 text-bold">-->
    <!--        Sort By-->
    <!--      </div>-->
    <!--      <sort-option-select></sort-option-select>-->
    <!--    </q-card-section>-->

  </div>

</template>

<script>
import Flags from "src/composables/Flags";
import PlanFilters from "src/composables/PlanFilters";
import Plans from "src/composables/Plans";
import Tdsps from "src/composables/Tdsps";
import SortOptionSelect from "components/plans/filters/SortOptionSelect";
import Terms from "src/composables/Terms";
import Brands from "src/composables/Brands";
import SelectedFilters from "components/plans/filters/SelectedFilters";

export default {
  name: "ToggleFilter",
  components: { SelectedFilters, SortOptionSelect },
  setup() {
    const { only_100_percent_green, only_time_of_use, only_no_deposit, include_auto_pay } = Flags();
    const { filtered_plans, total_plans } = Plans();
    const { clear_zip_code, zip_code, selected_tdsp } = Tdsps();
    const { clear_term_selection } = Terms();

    const {
      clear_all_filters,
      has_no_contract_filter,
      filter_no_contract,
      has_long_term_filter,
      filter_long_term,
      has_no_filters
    } = PlanFilters();


    const toggle_long_term = function () {
      if (has_long_term_filter.value) {
        clear_term_selection()
      }
      else {
        filter_long_term()
      }
    }

    const toggle_no_contract = function () {
      if (has_no_contract_filter.value) {
        clear_term_selection()
      }
      else {
        filter_no_contract()
      }
    }

    return {
      selected_tdsp,
      zip_code,
      filtered_plans,
      total_plans,

      only_100_percent_green,
      only_no_deposit,
      only_time_of_use,
      include_auto_pay,

      has_no_contract_filter,
      has_long_term_filter,
      has_no_filters,

      clear_zip_code,
      clear_all_filters,
      clear_term_selection,
      toggle_no_contract,
      toggle_long_term,
    }
  }
}
</script>

<style scoped>
.q-item {
  padding-left: 0px;
}
</style>
